<script setup lang="ts">
import SpinnerIcon from '@/assets/Icons/SpinnerIcon.svg'

withDefaults(
  defineProps<{
    size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
  }>(),
  {
    size: 'md',
  },
)
</script>

<template>
  <div class="spinner-container" :class="size">
    <SpinnerIcon class="spinner" />
  </div>
</template>

<style lang="scss" scoped>
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  --scale: 1;

  &.xs {
    --scale: 0.5;
  }
  &.sm {
    --scale: 0.7;
  }
  &.md {
    --scale: 1;
  }
  &.lg {
    --scale: 1.5;
  }
  &.xl {
    --scale: 2;
  }
  width: calc(var(--scale) * 34px);
  height: calc(var(--scale) * 34px);
}

.spinner {
  animation: spin 1.5s linear infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>
